import en from './en';
import LOCALES from '../locales';

export default {
  [LOCALES.ENGLISH]: { ...en },
};
